import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_HOST_INSURANCE_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

// Descuento del seguro para superanfitriones: compensa exactamente la línea del
// seguro (importe positivo, includeFor ['provider']) de modo que el coste neto
// para el anfitrión es cero. Solo aparece en la vista del anfitrión superhost;
// el bañista no lo ve. El importe vive en el servidor (fuente de verdad).
const LineItemHostInsuranceDiscountMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const discountLineItem = lineItems.find(
    item => item.code === LINE_ITEM_HOST_INSURANCE_DISCOUNT && !item.reversal
  );

  if (!isProvider || !discountLineItem) {
    return null;
  }

  const total = discountLineItem.lineTotal;
  const formattedTotal = total instanceof Money ? formatMoney(intl, total) : null;

  return formattedTotal ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.hostInsuranceDiscount" />
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  ) : null;
};

LineItemHostInsuranceDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemHostInsuranceDiscountMaybe;
